<!-- eslint-disable max-len -->
<template>
  <div style="display: flex; flex-direction: column; gap: 24px">
    <div class="card-container">
      <div class="card" :style="{ background: model ? '#ECFDF5' : '#FEF2F2' }">
        <div class="check">
          <h3 class="title" :style="{ color: model ? '#047857' : '#B91C1C' }">
            {{ model ? `Proteja sua compra por apenas ${insuranceData.insurancePerDay} por dia` : 'Sua compra está desprotegida' }}
          </h3>
          <span class="item">
            <CheckCircleIcon v-if="model" class="icon insurance" />
            <XCircleIcon v-else class="icon" />
            Pagamento parcial ou total da dívida
          </span>
          <span class="item">
            <CheckCircleIcon v-if="model" class="icon insurance" />
            <XCircleIcon v-else class="icon" />
            Proteção contra imprevistos financeiros
          </span>
          <div class="toggle">
            <AppToggle color="#10B981" v-model="model" @click="$emit('change')" />
            <span style="font-size: 14px; width: 100%">
              Ao ativar o seguro, declaro que li e aceito os
              <a @click="showTermsModal" href="#!" class="modalLink"> termos </a> e
              <a @click="showTermsConditions" href="#!" class="modalLink"> condições </a>
              das coberturas contratadas
            </span>
          </div>
        </div>
      </div>
    </div>
    <TermsModal
      ref="termsModal"
    />
    <ConditionsModal
      ref="conditionsModal"
    />
  </div>
</template>

<script>
import { CheckCircleIcon, XCircleIcon } from '@vue-hero-icons/outline';
import AppToggle from '@/components/ui/AppToggle.vue';
import TermsModal from '@/feature/onboarding/components/TermsModal.vue';
import ConditionsModal from '@/feature/onboarding/components/ConditionsModal.vue';

export default {
  name: 'insurance-options',
  props: {
    value: Boolean,
    options: Object,
  },
  data: () => ({
    model: true,
  }),
  watch: {
    model(oldValue) {
      this.$emit('input', oldValue);
    },
  },
  computed: {
    insuranceData() {
      const { totalAmount: totalOriginal } = this.options.originalOption;
      const { totalAmount: totalInsurance, numberOfInstallments } = this.options.insuranceOption;

      const difference = totalInsurance - totalOriginal;
      const numberOfInsuranceMonths = numberOfInstallments >= 12 ? 12 : numberOfInstallments;
      const insurancePerDay = (difference / (30 * numberOfInsuranceMonths)).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
      const insuranceInstallment = Number((difference / numberOfInstallments).toFixed(2));
      const insuranceInstallmentFormatted = insuranceInstallment.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });

      return {
        insurancePerDay,
        installments: numberOfInstallments,
        insuranceFirstInstallment: insuranceInstallmentFormatted,
      };
    },
    showProductListMobile() {
      return this.isMobile() && this.order && this.order.products;
    },
  },
  mounted() {
    this.model = this.value;
  },
  components: { CheckCircleIcon, XCircleIcon, AppToggle, ConditionsModal, TermsModal },
  methods: {
    showTermsModal() {
      this.scroll = window.scrollY;
      this.$refs.termsModal.showTermsModal();
    },
    showTermsConditions() {
      this.scroll = window.scrollY;
      this.$refs.conditionsModal.showTermsConditions();
    },
  },
};
</script>
<style lang="scss" scoped>
.card-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;

  > .card {
    display: flex;
    padding: 12px;
    flex-direction: column;
    justify-content: center;
    gap: 16px;
    align-self: stretch;
    border: none;
    border-radius: 8px;

    > .check {
      display: flex;
      flex-direction: column;
      gap: 12px;

      > .title {
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
      }

      > .item {
        display: flex;
        align-items: center;
        gap: 4px;
        align-self: stretch;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;

        > .icon {
          height: 20px;
          width: 20px;
          color: #b91c1c;

          &.insurance {
            color: #047857;
          }
        }
      }

      > .toggle {
        display: flex;
        align-items: center;
        flex-direction: row;
        width: 100%;
        gap: 8px;

        .modalLink {
          cursor: pointer;
          padding: 0;
          outline: none;
          border: none;
          color: #0f172a;
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 20px;
          text-decoration-line: underline;
        }
      }
    }
  }
}

</style>
